var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M14 4H4C2.343 4 1 5.343 1 7V17C1 18.657 2.343 20 4 20H14C15.657 20 17 18.657 17 17V16L19 12L17 7.993V7C17 5.343 15.657 4 14 4Z",
    fill: "black",
    fillOpacity: 0.95
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0002 22.0002C20.7442 22.0002 20.4882 21.9023 20.2932 21.7073L2.29325 3.70725C1.90225 3.31625 1.90225 2.68425 2.29325 2.29325C2.68425 1.90225 3.31625 1.90225 3.70725 2.29325L21.7073 20.2932C22.0983 20.6842 22.0983 21.3163 21.7073 21.7073C21.5123 21.9023 21.2562 22.0002 21.0002 22.0002Z",
    fill: "black",
    fillOpacity: 0.95
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 7.993L20.657 6.171C20.883 6.058 21.131 6 21.383 6C22.278 6 23.005 6.722 23.011 7.617L23.073 16.36C23.08 17.264 22.349 18 21.445 18H21.384C21.131 18 20.882 17.941 20.656 17.828L17 16V7.993Z",
    fill: "black",
    fillOpacity: 0.95
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.c841d1145a4091178517a5b7a13831ce.svg";
export { ForwardRef as ReactComponent };